import { styled, ThemeProps } from '@teko/ds-mobile';
import React from 'react';

export interface ProgressBarProps extends ThemeProps {
  progress?: number;
  barColor?: string;
  barHeight: number;
  barBorder?: number;
  backgroundColor?: string;
  barContent?: React.ReactNode;
  justify?: string;
}

export interface BarProps extends ThemeProps {
  height: number;
  color?: string;
  border?: number;
  progressPercentage?: number;
}

const StyledBar = styled.div<ProgressBarProps>(
  ({
    barHeight,
    barBorder,
    theme,
    backgroundColor,
    justify,
  }: ProgressBarProps) => `
  height: ${barHeight}px;
  border-radius: ${barBorder}px;
  background-color: ${backgroundColor || theme?.colors.disable};
  overflow: hidden;
  position: relative;
  margin: 0.25rem 0;
  align-items: center;
  justify-content: ${justify};
  display: flex;
  width: 100%;
`,
);

const Progress = styled.div<BarProps>(
  ({ height, border, progressPercentage, theme, color }: BarProps) => {
    return `
  background-color: ${color || theme?.colors.primary};
  position: absolute;
  z-index: 1;
  height: inherit;
  border-radius: ${border}px;
  height: ${height}px;
  width: ${progressPercentage}%;
  transition: width 0.3s ease-in-out;
`;
  },
);

export const ProgressBar: React.FC<ProgressBarProps> = ({
  progress = 0,
  barColor,
  barHeight = 4,
  barBorder = barHeight / 2,
  backgroundColor,
  barContent,
  justify,
}: ProgressBarProps) => {
  return (
    <StyledBar
      barHeight={barHeight}
      barBorder={barBorder}
      backgroundColor={backgroundColor}
      justify={justify}
    >
      {barContent}
      <Progress
        progressPercentage={progress}
        color={barColor}
        height={barHeight}
        border={barBorder}
      />
    </StyledBar>
  );
};
